import { Components, Theme } from "@mui/material";
import { LoadingButtonProps } from "@mui/lab";

declare module "@mui/material/styles" {
  interface Components {
    MuiLoadingButton?: {
      defaultProps?: Partial<LoadingButtonProps>;
      styleOverrides?: {
        root?: React.CSSProperties;
      };
    };
  }
}

export const muiLoadingButton: Components<Theme>["MuiLoadingButton"] = {
  styleOverrides: {
    root: {
      textTransform: "none",
    },
  },
};
